import { styled } from '@mui/material/styles'
import Stack from '@mui/material/Stack'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import Check from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector'
import { StepIconProps } from '@mui/material/StepIcon'
import { Typography } from '@mui/material'
import { steps } from 'configs/constants'

const Connector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 22px)',
    right: 'calc(50% + 22px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage: 'linear-gradient(300.96deg, #B79313 18.75%, rgba(183, 147, 19, 0.3) 81.54%)',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage: 'linear-gradient(300.96deg, #B79313 18.75%, rgba(183, 147, 19, 0.3) 81.54%)',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: theme.palette.grey[800],
    borderRadius: 1,
  },
}))

const ColorlibStepIconRoot = styled('div')<{
  ownerState: { completed?: boolean; active?: boolean }
}>(({ theme, ownerState }) => ({
  'backgroundColor': theme.palette.mode === 'dark' ? theme.palette.grey[700] : 'transparent',
  'zIndex': 1,
  'width': 32,
  'height': 32,
  'display': 'flex',
  'borderRadius': '50%',
  'justifyContent': 'center',
  'alignItems': 'center',
  'boxShadow': '0px 4px 24px -1px rgba(0, 0, 0, 0.2)',
  'backdropFilter': 'blur(25px)',
  'backgroundImage': 'linear-gradient(90.18deg, rgba(50, 56, 91, 0.57) 0%, rgba(26, 31, 65, 0.57) 100%)',
  'border': '1px solid #ffffff50',
  ...(ownerState.active && {
    backgroundImage:
      'linear-gradient(153.32deg, #B79313 -65.62%, rgba(233, 209, 107, 0.1) 83.28%), linear-gradient(142.08deg, rgba(255, 255, 255, 0.7) -5.03%, rgba(188, 188, 188, 0.85) 21.3%, rgba(13, 16, 35, 0.4) 49.04%, rgba(7, 7, 10, 0.5) 70.19%)',
    border: 'none',
  }),
  ...(ownerState.completed && {
    backgroundImage:
      'linear-gradient(153.32deg, #B79313 -65.62%, rgba(233, 209, 107, 0.1) 83.28%), linear-gradient(142.08deg, rgba(255, 255, 255, 0.7) -5.03%, rgba(188, 188, 188, 0.85) 21.3%, rgba(13, 16, 35, 0.4) 49.04%, rgba(7, 7, 10, 0.5) 70.19%)',
    border: 'none',
  }),
  '& .QontoStepIcon-circle': {
    textAlign: 'center',
    color: '#FFFFFF',
  },
}))

const StepperSx = {
  '& .MuiStepConnector-line': {
    marginTop: '38px',
  },
}

type ProgressProps = {
  id?: number
}

export const Progress = (props: ProgressProps) => {
  const { id } = props

  const StepIcon = (props: StepIconProps) => {
    const { active, completed, className, icon } = props
    return (
      <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
        {completed ? <Check /> : <>{active ? <>{id === 8 ? <CloseIcon /> : <Check />}</> : <div className="QontoStepIcon-circle">{icon}</div>}</>}
      </ColorlibStepIconRoot>
    )
  }

  return (
    <Stack className="stepperBox" sx={{ width: '100%', overflow: 'auto', padding: '1.25rem 1rem' }} spacing={4}>
      <Stepper activeStep={id} alternativeLabel sx={StepperSx} connector={<Connector />}>
        {steps.map(label => (
          <Step key={label}>
            <Typography align="center" style={{ marginBottom: '.75rem', whiteSpace: 'pre' }}>
              {label}
            </Typography>
            <StepLabel StepIconComponent={StepIcon} />
          </Step>
        ))}
      </Stepper>
    </Stack>
  )
}
